/**
 * Modèle des choix pour les questions à choix multiple :
 * tableau de { label, voice_followup?, followup_robot_text? }.
 * Ancien format : tableau de chaînes, ou type legacy `multiple_choice_voice`.
 */

function normalizeFollowupText(raw) {
  if (raw == null) return '';
  if (typeof raw === 'string') return raw.trim();
  return String(raw).trim();
}

export function choiceLabel(entry) {
  if (entry == null) return '';
  if (typeof entry === 'string') return entry;
  if (typeof entry === 'object' && typeof entry.label === 'string') return entry.label;
  return String(entry?.label ?? '');
}

export function normalizeChoicesArray(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.map((item) => {
    if (typeof item === 'string') {
      return { label: item, voice_followup: false, followup_robot_text: '' };
    }
    if (item && typeof item === 'object') {
      const label = typeof item.label === 'string' ? item.label : '';
      return {
        label,
        voice_followup: Boolean(item.voice_followup),
        followup_robot_text: normalizeFollowupText(item.followup_robot_text),
      };
    }
    return { label: '', voice_followup: false, followup_robot_text: '' };
  });
}

/** Normalise type + choix après lecture BDD / API. */
export function migrateQuestionFromStore(q) {
  if (!q || typeof q !== 'object') return q;
  const type = q.type === 'multiple_choice_voice' ? 'multiple_choice' : q.type;
  let choices = q.choices;
  if (q.type === 'multiple_choice_voice') {
    choices = normalizeChoicesArray(choices).map((c) => ({ ...c, voice_followup: true }));
  } else if (type === 'multiple_choice') {
    choices = normalizeChoicesArray(choices);
  } else {
    choices = Array.isArray(choices) ? choices : [];
  }
  return { ...q, type, choices };
}

export function emptyChoiceForForm() {
  return { label: '', voice_followup: false, followup_robot_text: '' };
}

/** Une ligne de choix prête pour le formulaire admin (au moins une ligne vide si besoin). */
export function choicesForAdminForm(raw) {
  const n = normalizeChoicesArray(raw);
  if (n.length === 0) return [emptyChoiceForForm()];
  return n;
}

export function choiceHasVoiceFollowup(question, selectedLabel) {
  if (!question || question.type !== 'multiple_choice') return false;
  const sel = String(selectedLabel ?? '').trim();
  for (const c of question.choices || []) {
    if (choiceLabel(c).trim() === sel && c.voice_followup) return true;
  }
  return false;
}

/** Texte vocal après un choix « voix » ; chaîne vide = le robot ne dit rien. */
export function choiceFollowupRobotText(question, selectedLabel) {
  if (!question || question.type !== 'multiple_choice') return '';
  const sel = String(selectedLabel ?? '').trim();
  for (const c of question.choices || []) {
    if (choiceLabel(c).trim() === sel && c.voice_followup) {
      return normalizeFollowupText(c.followup_robot_text);
    }
  }
  return '';
}
